module.exports = __webpack_public_path__ + "growth-b95fe7354e444951dc6ff78f6bbc2195.png";